import { SUPPORTED_LANGUAGES } from "./Constants";
import i18n from "./i18n.js";
import getBrowserLocale from "./GetBrowserLocale";

const Trans = {
  get defaultLanguage() {
    return getBrowserLocale({ countryCodeOnly: true });
  },
  get supportedLanguages() {
    return SUPPORTED_LANGUAGES;
  },
  get currentLanguage() {
    return i18n.locale;
  },
  set currentLanguage(lang) {
    i18n.locale = lang;
  },
  /**
   * Gets the first supported language that matches the user's
   */
  getUserSupportedLang() {
    const userPreferredLang = Trans.getUserLang();

    // Check if user preferred browser lang is supported
    if (Trans.isLangSupported(userPreferredLang.lang)) {
      return userPreferredLang.lang;
    }
    // Check if user preferred lang without the ISO is supported
    if (Trans.isLangSupported(userPreferredLang.langNoISO)) {
      return userPreferredLang.langNoISO;
    }
    return Trans.defaultLanguage;
  },
  /**
   * Returns the users preferred language
   */
  getUserLang() {
    const lang =
      getBrowserLocale({ countryCodeOnly: true }) ||
      Trans.defaultLanguage ||
      window.navigator.language;
    return {
      lang: lang,
      langNoISO: lang.split("-")[0],
    };
  },
  /**
   * Sets the language to various services (axios, the html tag etc)
   */
  setI18nLanguageInServices(lang) {
    Trans.currentLanguage = lang;
    document.querySelector("html").setAttribute("lang", lang);
    return lang;
  },
  /**
   * Loads new translation messages and changes the language when finished
   */
  changeLanguage(lang) {
    if (!Trans.isLangSupported(lang))
      return Promise.reject(new Error("Language not supported"));
    if (i18n.locale === lang) return Promise.resolve(lang); // has been loaded prior
    return Trans.loadLanguageFile(lang).then((msgs) => {
      i18n.setLocaleMessage(lang, msgs.default || msgs);
      return Trans.setI18nLanguageInServices(lang);
    });
  },
  /**
   * Async loads a translation file
   */
  loadLanguageFile(lang) {
    return import(
      /* webpackChunkName: "lang-[request]" */ `../locales/${lang}.json`
    );
  },
  /**
   * Checks if a lang is supported
   */
  isLangSupported(lang) {
    return Trans.supportedLanguages.includes(lang);
  },
};

export { Trans };
